import { IEmpreendimento } from "../../../../Interfaces/Geral/Produtos/ProdutosInterface";
import "./styles.css";
import TabsCadastroEEditaProduto from "./TabsCadastroEEditaProduto";

interface ICadastrarEEditarProdutoProps {
    editando?: boolean;
    updateList: () => void;
    row?: IEmpreendimento;
}

export default function CadastraEEditaProduto(
    props: ICadastrarEEditarProdutoProps
) {
    // const { reset } = FormMethods;
    const { editando } = props;

    return (
        <div>
            <TabsCadastroEEditaProduto
                updateList={props.updateList}
                editando={editando}
                row={props.row}
            />
        </div>
    );
}
